import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArtigosSidebar from './sidebar';
import CriarArtigo from './CriarArtigo';
import VerArtigosPorFamilia from './VerArtigosPorFamilia';
import VerArtigosPorReferencia from './VerArtigosPorReferencia';
import VerArtigosPorFornecedor from './VerArtigosPorFornecedor';

const ArtigosLayout = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'criar':
                return <CriarArtigo />;
            case 'porFamilia':
                return <VerArtigosPorFamilia />;
            case 'porReferencia':
                return <VerArtigosPorReferencia />;
            case 'porFornecedor':
                return <VerArtigosPorFornecedor />;
            default:
                return (
                    <Typography variant="body1" align="center">
                        Selecione uma opção do menu para exibir o conteúdo.
                    </Typography>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {sidebarVisible && (
                <Box
                    sx={{
                        width: '300px',
                        borderRight: '1px solid #ccc',
                        position: 'relative'
                    }}
                >
                    <ArtigosSidebar onOptionChange={handleOptionChange} />
                    <IconButton
                        onClick={() => setSidebarVisible(false)}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-20px',
                            backgroundColor: 'white',
                            boxShadow: 1
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            )}
            {!sidebarVisible && (
                <IconButton
                    onClick={() => setSidebarVisible(true)}
                    sx={{
                        position: 'absolute',
                        left: '0px',
                        top: '50%',
                        backgroundColor: 'white',
                        boxShadow: 1,
                        zIndex: 1
                    }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            <Box sx={{ flexGrow: 1, p: 2, overflowY: 'auto', maxHeight: '100vh' }}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default ArtigosLayout;
